import { useState, useEffect } from 'react'
import { getPaymentEmployeeSelectAPI } from '../services/more-dropdown'

function UseSearchEmployeePayment(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const body = {
        searchs,
        orgId,
        page: 1,
        size: 20
      }
      const resp = await getPaymentEmployeeSelectAPI(body)
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d) => ({
          ...d,
          value: d?.username,
          label: `${d?.org ?? ''} - ${d?.code ?? ''} - ${d?.nameThFull ?? ''} `
        }))
        setData(newData)
      } else {
        setData([])
      }
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseSearchEmployeePayment
